<app-status-slider
  [slider]="slider"
  [title]="title"
  [secondeRangeColor]="secondeRangeColor"
  [thirdRangeColor]="thirdRangeColor"
>
</app-status-slider>
